module.exports = __webpack_public_path__ + "img/loading.d276a0d4.svg";